import { Amplify } from "aws-amplify";

const initAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || "",
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "",
        loginWith: {
          oauth: {
            redirectSignIn: [`${window.location.origin}`],
            redirectSignOut: [`${window.location.origin}/sign-in`],
            providers: ["Google", "Facebook", "Apple"],
            domain: process.env.REACT_APP_COGNITO_DOMAIN || "",
            scopes: [
              "email",
              "profile",
              "openid",
              "aws.cognito.signin.user.admin",
            ],
            responseType: "code",
          },
        },
      },
    },
  });
};

export default initAmplify;
